"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var LiveState;
(function (LiveState) {
    LiveState["NONE"] = "live-state/none";
    LiveState["INITIAL"] = "live-state/initial";
    LiveState["NOT_SYNC"] = "live-state/not-sync";
    LiveState["SYNC"] = "live-state/sync";
    LiveState["ENDED"] = "live-state/ended";
})(LiveState || (LiveState = {}));
exports.default = LiveState;
//# sourceMappingURL=live-state.js.map